module.exports = __webpack_public_path__ + "img/01.4a8cec90.png";